
export const breadcrumbRoutes = [
  // Auth
  { path: "/", name: "Login" },
  { path: "/login", name: "Login" },

  // Booking
  { path: "/createbooking", name: "Create Booking" },
  { path: "/allbooking", name: "All Bookings" },
  { path: "/bookingpayment", name: "Booking Payment" },
  { path: "/bookingpayment/:transactionId", name: "Booking Payment" },
  { path: "/bookingtransactionlists", name: "Booking Transactions" },
  { path: "/seetransactionpayment", name: "See Transaction Payment" },
  { path: "/seetransaction/:booking_id", name: "Transaction Details" },
  { path: "/seetransactionslip/:transactionId", name: "Transaction Slip" },
  { path: "/changeplot/:booking_id", name: "Change Plot" },
  { path: "/BookedDetailpage/:bookedId", name: "Booked Details" },
  { path: "/BookingPrintpage/:bookingId", name: "Booking Print" },
  { path: "/BookingPlotDetails/:customerId", name: "Booking Plot Details" },
  { path: "/seecanceledbooking", name: "Canceled Bookings" },

  // Customer
  { path: "/customerlists", name: "Customer List" },
  { path: "/customerlist", name: "Customer List" },
  { path: "/createcustomer", name: "Create Customer" },
  { path: "/updatecustomer/:updatecustomerid", name: "Update Customer" },

  // Associate / Broker
  { path: "/allassociate", name: "All Associates" },
  { path: "/createassociate", name: "Create Associate" },
  { path: "/updateassociate/:updateassociateid", name: "Update Associate" },
  { path: "/associatepayment/:broker_id", name: "Associate Payment" },
  { path: "/associatebookingsdetails/:associateid", name: "Associate Booking Details" },
  { path: "/transactionprint/:broker_id", name: "Transaction Print" },

  // Plot / Site
  { path: "/createsite", name: "Create Site" },
  { path: "/sitelists", name: "Site List" },
  { path: "/createplot", name: "Create Plot" },
  { path: "/plotlists", name: "Plot List" },
  { path: "/updateplot/:updateplotid", name: "Update Plot" },
  { path: "/changeplot/:booking_id", name: "Change Plot" },

  // Commission
  { path: "/commission", name: "Commission" },

  // Transactions
  { path: "/updatetransaction", name: "Update Transaction" },

  // Users
  { path: "/createuser", name: "Create User" },
  { path: "/changepassword", name: "Change Password" },
];

export default breadcrumbRoutes;
